import { actionGenerator, IReduxAction } from '../../utils/actions';

export const CHANGE_CURRENT_OVER_SERVICE_BET = 'AUCTION :: CHANGE_CURRENT_OVER_SERVICE_BET';

export type TChangeCurrentOverServiceBetAction = IReduxAction<typeof CHANGE_CURRENT_OVER_SERVICE_BET, number>;

export const changeCurrentOverServiceBet = actionGenerator<typeof CHANGE_CURRENT_OVER_SERVICE_BET, number>(
  CHANGE_CURRENT_OVER_SERVICE_BET,
);
